export const FETCH_PERSON_PHONE_NUMBER_END = "fetchPersonPhoneNumbersEnd";
export const LOAD_PERSON_PHONE_NUMBER_TO_EDIT = "loadPersonPhoneNumberToEdit";
export const LOAD_PERSON_PHONE_NUMBER_TO_VIEW = "LOAD_PERSON_PHONE_NUMBER_TO_VIEW";
export const RESET_DEFAULT_NEW_PERSON_PHONE_NUMBER = "resetDefaultNewPersonPhoneNumber";
export const RESET_DEFAULT_PERSON_PHONE_NUMBER_TO_EDIT = "resetDefaultPersonPhoneNumberToEdit";
export const TOGGLE_EDIT_PERSON_PHONE_NUMBER_DIALOG = "toggleEditPersonPhoneNumberDialog";
export const TOGGLE_NEW_PERSON_PHONE_NUMBER_DIALOG = "toggleAddPersonPhoneNumberDialog";
export const TOGGLE_VIEW_PERSON_PHONE_NUMBER_DIALOG = "TOGGLE_VIEW_PERSON_PHONE_NUMBER_DIALOG";
export const UPDATE_ADD_PERSON_PHONE_NUMBER_FIELD = "updateAddPersonPhoneNumberField";
export const UPDATE_PERSON_PHONE_NUMBER_FIELD = "updatePersonPhoneNumberField";
